import { withRouter } from '~HOC';
import { connect } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { jwtApi } from '../../../services/apis';
import { Link, useLocation } from 'react-router-dom';
import MobileHeader from './mobileHeader/mobileHeader';
import { FormattedMessage, injectIntl } from 'react-intl';
import { changeLanguage } from '../../../actions/language';
import { SignOutClearStore } from '../../../utils/clearData';
import { LanguageSelect, HeaderAuth } from '../../../component';
import React, { useState, memo, useEffect, useRef } from 'react';
import { origin } from '../../../utils/consts/general';
import MobileProfileHeader from './mobileProfileHeader/mobileProfileHeader';
import {
  profileRoutes,
  flightBookingRoutes,
  commonRoute,
  gamesRoute,
} from '../../../utils/consts/routes';
import {
  ShoppingBagIcon,
  UserCogIcon,
  UserIdBadgeIcon,
  HeadsetIcon,
  CoinIcon,
  UserReportIcon,
  CustomerClubIcon,
  UserTieIcon,
  AirplaneIcon,
  AirlineIcon,
  BarcodeIcon,
  DashboardIcon,
  InfoCircleIcon,
  FeaturesIcon,
  HotelIcon,
  GatewayIcon,
} from '~svg';
import tripordLogo from '../../../content/images/icon/tripord-logo.webp';
import tripsiLogo from '../../../content/images/icon/tripsi-logo.webp';
import './header.scss';

const Header = ({ ...props }) => {
  const { userInfo, location } = props;
  const { pathname } = useLocation();
  const [showMobileMenu, setShowMobileMenu] = useState();
  const { direction, name } = props.language;
  const [selectedTab, setSelectedTab] = useState('select-city');

  useEffect(() => {
    setSelectedTab(location.pathname.split('/').at(-1));
    if (props.token) {
      const decodedToken = jwtDecode(props.token);
      const currentTime = Date.now() / 1000;
      if (decodedToken.exp < currentTime) SignOutClearStore();
    }
    // jwtApi.verify();
  }, [location]);

  const signOut = async () => {
    try {
      await jwtApi
        .signOut()
        .then((res) => {
          if (res?.status === 200 && res?.payload?.data === 1) {
            SignOutClearStore();
            props.navigate('/');
          }
        })
        .catch((error) => {
          console.error('error');
        })
        .finally(() => {
          SignOutClearStore();
          props.navigate('/');
        });
    } catch (error) {
      SignOutClearStore();
      props.navigate('/');
    }
  };

  const renderLoginLink = (
    location,
    direction,
    setShowMobileMenu,
    color = 'text-primary-dark',
  ) => {
    let params = location.search;
    if (pathname.includes('booking')) {
      let target = '';
      if (params.includes('target')) {
        target = params.substring(params.indexOf('target'), params.length);
        if (target.includes('&'))
          target = target.substring(0, target.indexOf('&'));
        params.split('&').splice(target);
      }
      params = `${params}${
        params.includes('?') ? `&target=${pathname}` : `?target=${pathname}`
      }`;
    }
    return (
      <div
        className={`col-md-3 col px-md-2 px-0 d-flex align-items-center justify-content-end font-md-msmall font-sm-normal font-small ${color}`}
      >
        <Link
          to={params ? `/login${params}` : '/login'}
          className={`border-third ${
            direction === 'ltr' ? 'border-right pr-2' : 'border-left pl-2'
          } ${color} `}
          onClick={() => setShowMobileMenu(false)}
        >
          <FormattedMessage id="header.login" />
        </Link>
        <Link
          to={params ? `/signup${params}` : '/signup'}
          className={`${direction === 'ltr' ? 'pl-2' : 'pr-2'} ${color}`}
          onClick={() => setShowMobileMenu(false)}
        >
          <FormattedMessage id="header.signup" />
        </Link>
      </div>
    );
  };

  const renderUsersInfo = (userInfo) => {
    if (userInfo?.user?.[0]?.basicInfo) {
      let fullName = `${userInfo.user[0].firstName}`;
      return <HeaderAuth signOut={signOut} fullName={fullName} />;
    }
  };

  const renderChangeLanguage = () => (
    <LanguageSelect
      language={props.language}
      changeLanguage={props.changeLanguage}
    />
  );

  let isLogOut = !userInfo?.user || userInfo?.user.length <= 0;
  // let { basicInfo } = userInfo?.user[0] ?? false;
  let { basicInfo } = userInfo?.user?.[0] ?? false;
  const services = [
    {
      icon: <AirplaneIcon size={22} color="#80c494" />,
      label: 'booking.flight',
      link: '/',
    },
  ];

  const businessDashboarditems = [
    {
      icon: <UserTieIcon size={22} color="#80c494" variant="mx-1" />,
      label: 'profile.businessprofile',
      link: profileRoutes.businessProfile,
    },
    {
      icon: <UserReportIcon size={22} color="#80c494" variant="mx-1" />,
      label: 'profile.employeeManagement',
      link: profileRoutes.employeeManagement,
    },
    {
      icon: <UserCogIcon size={22} color="#80c494" variant="mx-1" />,
      label: 'profile.customerManagement',
      link: profileRoutes.customerManagement,
    },
    {
      icon: <HeadsetIcon size={22} color="#80c494" variant="mx-1" />,
      label: 'profile.onlinesupport',
      link: profileRoutes.ticket,
    },
    {
      icon: <CustomerClubIcon size={22} color="#80c494" variant="mx-1" />,
      label: 'footer.customerClub',
      link: profileRoutes.commissionManagement,
    },
    {
      icon: <ShoppingBagIcon size={22} color="#80c494" variant="mx-1" />,
      label: 'profile.businessbooking',
      link: profileRoutes.bookingFlights,
    },
    {
      icon: <CoinIcon size={22} color="#80c494" variant="mx-1" />,
      label: 'profile.financialmanagement',
      link: profileRoutes.financialManagement,
    },
    {
      icon: <GatewayIcon size={22} color="#80c494" variant="mx-1" />,
      label: 'profile.gatewayroutes',
      link: profileRoutes.gateway,
    },
  ];

  const individualDashboarditems = [
    {
      icon: <UserIdBadgeIcon size={24} color="#80c494" variant="mx-1" />,
      label: 'profile.profile',
      link: profileRoutes.userBasicInfo,
    },
    {
      icon: <HeadsetIcon size={22} color="#80c494" variant="mx-1" />,
      label: 'profile.onlinesupport',
      link: profileRoutes.ticket,
    },
    {
      icon: <CustomerClubIcon size={22} color="#80c494" variant="mx-1" />,
      label: 'footer.customerClub',
      link: profileRoutes.commissionManagement,
    },
    {
      icon: <ShoppingBagIcon size={22} color="#80c494" variant="mx-1" />,
      label: 'profile.book/reserve',
      link: profileRoutes.bookingFlights,
    },
    {
      icon: <CoinIcon size={22} color="#80c494" variant="mx-1" />,
      label: 'profile.financialmanagement',
      link: profileRoutes.financialManagement,
    },
  ];

  let profileFlag = localStorage.getItem('profile');

  return (
    <header
      className={`${
        pathname.includes('profile')
          ? 'd-flex justify-content-center'
          : 'd-flex'
      } flex-column align-items-center mainheader  ${
        pathname.includes('profile') && 'px-1'
      }  border-bottom align-items-center text-nowrap`}
    >
      <div
        className={`w-100 h-100 text-primary-dark font-weight-bold ${
          pathname.includes('profile') ? 'd-lg-flex d-none' : 'd-md-flex d-none'
        } flex-row justify-content-between align-items-center py-2 ${
          pathname.includes('profile') ? 'px-4' : 'px-4 px-xl-5'
        } border-top`}
      >
        <div className="w-100 h-100 font-weight-bold d-md-flex flex-row justify-content-between align-items-center py-1">
          <Link
            className={`d-flex align-items-center border-2 col-2 px-0 cursor-default`}
            to={flightBookingRoutes.selectCity}
          >
            <img
              className={`p-0 font-small cursor-pointer`}
              src={
                window?.location?.origin?.includes?.('tripord')
                  ? tripordLogo
                  : tripsiLogo
              }
              width={130}
              height={
                window?.location?.origin?.includes?.('tripord')
                  ? '40px'
                  : '55px'
              }
              alt={
                window?.location?.origin?.includes?.('tripord')
                  ? 'tripord icon'
                  : 'tripsi icon'
              }
            />
          </Link>
          <div
            className={`d-flex flex-row justify-content-between col-lg-5 col-6 p-0 ${
              direction === 'rtl' && 'text-right'
            }`}
            id="navbarNav"
          >
            <ul className="w-100 m-0 p-0 d-flex flex-row justify-content-around align-items-center font-xl-msmall font-msmall">
              <li className="mx-1 cursor-pointer">
                <div className="px-1 d-flex align-items-center">
                  <AirlineIcon
                    color={
                      selectedTab === 'select-city' ? '#00798c' : '#343d71'
                    }
                  />
                </div>
                <Link
                  className="text-primary-dark"
                  to={flightBookingRoutes.selectCity}
                >
                  <FormattedMessage id="header.book" />
                </Link>
              </li>
              <li
                style={{
                  opacity: 0.5,
                  cursor: 'not-allowed',
                }}
                className="mx-1 "
              >
                <div className="px-1 d-flex align-items-center ">
                  <HotelIcon color={'#343d71'} size={20} />
                </div>
                {/* <Link
                  className="text-primary-dark d-flex align-items-center"
                  // to="https://hotel.tripsi.ir"
                > */}
                <FormattedMessage id="footer.hotel" />
                {/* </Link> */}
              </li>
              {!isLogOut && (
                <>
                  {(!userInfo?.user || userInfo?.user?.length <= 0) && (
                    <li className="mx-1 cursor-pointer">
                      <div className="px-1 d-flex align-items-center">
                        <BarcodeIcon
                          color={
                            selectedTab === 'tracking-order'
                              ? '#00798c'
                              : '#343d71'
                          }
                        />
                      </div>
                      <Link
                        className="text-primary-dark"
                        to={flightBookingRoutes.trackingOrder}
                      >
                        <FormattedMessage id="booking.trackorder" />
                      </Link>
                    </li>
                  )}
                  {userInfo?.user?.length && !pathname.includes('profile') ? (
                    <li className="mx-1 cursor-pointer">
                      <div className="px-1 d-flex align-items-center">
                        <DashboardIcon
                          color={
                            selectedTab === 'dashboard' ? '#00798c' : '#343d71'
                          }
                        />
                      </div>
                      <Link
                        className="text-primary-dark"
                        to={profileRoutes.dashboard}
                      >
                        <div>
                          <FormattedMessage id="header.manage" />
                        </div>
                      </Link>
                    </li>
                  ) : null}
                </>
              )}
              <li className="mx-1 cursor-pointer">
                <div className="px-1 d-flex align-items-center">
                  <InfoCircleIcon
                    color={selectedTab === 'about' ? '#00798c' : '#343d71'}
                  />
                </div>
                <Link className="text-primary-dark" to={'/about'}>
                  <FormattedMessage
                    id={`${
                      window?.location?.origin?.includes?.('tripord')
                        ? 'aboutus.tripord'
                        : 'aboutus.tripsi'
                    }`}
                  />
                </Link>
              </li>
              <li className={`mx-1 cursor-pointer position-relative`}>
                <div className="px-1 d-flex align-items-center">
                  <FeaturesIcon
                    color={
                      selectedTab === 'other-option' ? '#00798c' : '#343d71'
                    }
                  />
                </div>
                <div className="text-primary-dark">
                  <FormattedMessage id="otheroption.otheroptions" />
                </div>
                <div
                  className="w-100 mt-2 position-absolute py-2 showPopUpOtherOption d-flex align-items-end"
                  style={{
                    top: '-100px',
                    zIndex: 2,
                    minWidth: '6.5rem',
                    height: '10rem',
                  }}
                >
                  <div className="w-100 bg-white  border default-border-radius-xsmall shadow py-3">
                    <ol className="px-2 w-100">
                      <li className="w-100">
                        <Link
                          className="w-100 text-primary-dark"
                          to={commonRoute.otherOption}
                        >
                          <FormattedMessage id="profile.calendar" />
                        </Link>
                      </li>
                      <li
                        style={{
                          opacity: 0.5,
                          cursor: 'not-allowed',
                        }}
                        className="w-100 mt-3"
                      >
                        <div className="w-100 text-primary-dark diasable">
                          <FormattedMessage
                            id={`${
                              window?.location?.origin?.includes?.('tripord')
                                ? 'header.smarttripord'
                                : 'header.smarttripsi'
                            }`}
                          />
                        </div>
                      </li>
                      <li
                        style={{
                          opacity: 0.5,
                          cursor: 'not-allowed',
                        }}
                        className="w-100 mt-3"
                      >
                        {/* <Link className="w-100" to={gamesRoute.backgammon}>
                          <div className="text-primary-dark">
                            <FormattedMessage id={'profile.game'} />
                          </div>
                        </Link> */}
                        <div className="text-primary-dark">
                          <FormattedMessage id={'profile.game'} />
                        </div>
                      </li>
                    </ol>
                  </div>
                </div>
              </li>

              {isLogOut ? (
                <li className="mx-1 cursor-pointer">
                  <div className="px-1 d-flex align-items-center">
                    <BarcodeIcon
                      color={
                        selectedTab === 'tracking-order' ? '#00798c' : '#343d71'
                      }
                    />
                  </div>
                  <Link
                    className="text-primary-dark"
                    to={flightBookingRoutes.trackingOrder}
                  >
                    <FormattedMessage id="booking.trackorder" />
                  </Link>
                </li>
              ) : (
                <></>
              )}
            </ul>
          </div>
          <div className="d-flex flex-row justify-content-end align-items-center col-2 px-0">
            {!userInfo?.user?.length
              ? renderLoginLink(location, direction, setShowMobileMenu)
              : renderUsersInfo(userInfo)}
            <div
              className={`${
                direction === 'rtl' ? 'col-lg-6 col-3' : 'col-lg-8 col-3'
              } d-flex flex-row justify-content-end align-items-center px-0`}
            >
              {renderChangeLanguage()}
            </div>
          </div>
        </div>
      </div>
      <MobileHeader
        setShowMobileMenu={setShowMobileMenu}
        showMobileMenu={showMobileMenu}
        CloseMobileMenu={() => setShowMobileMenu(false)}
        renderChangeLanguage={renderChangeLanguage()}
        isLogOut={isLogOut}
        direction={direction}
        setSignOut={() => signOut()}
        userInfo={userInfo}
        renderLoginLink={renderLoginLink}
        renderUsersInfo={renderUsersInfo(userInfo)}
        urlLocation={origin}
      />
      <MobileProfileHeader
        showInprofile={pathname.includes('profile')}
        urlLocation={origin}
        showMobileMenu={showMobileMenu}
        basicInfo={basicInfo}
        direction={direction}
        dashboardServicelinks={services}
        isLogOut={isLogOut}
        pathname={pathname}
        profileFlag={profileFlag}
        userInfo={userInfo}
        intl={props.intl}
        profileRoutes={profileRoutes}
        individualDashboarditems={individualDashboarditems}
        businessDashboarditems={businessDashboarditems}
        flightBookingRoutes={flightBookingRoutes}
        CloseMobileMenu={() => setShowMobileMenu(false)}
        changeLanguage={renderChangeLanguage()}
        loginLink={renderLoginLink(location, direction, setShowMobileMenu)}
        changeStateshow={() => setShowMobileMenu(!showMobileMenu)}
        closeMenu={() => {
          setShowMobileMenu(false);
        }}
        signOut={() => {
          signOut();
          setShowMobileMenu(false);
        }}
      />
    </header>
  );
};

function mapStateToProps(state, props) {
  return {
    language: state.language,
    userInfo: state?.user?.userInfo,
    token: state.requestToken.barearToken,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeLanguage: (lang) => dispatch(changeLanguage(lang)),
  };
}

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(memo(Header))),
);
